import React from "react";
import { Container } from "react-bootstrap";
import {
  Heading,
  Paragraph,
} from "../../Components/TextComponents/TextComponents";
import styles from "./project.module.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { useNavigate } from "react-router-dom";

const ProjectSlider = () => {
  const navigate = useNavigate();
  const handleClickRedirect = () => {
    navigate(`/projectdetails`);
  };

  return (
    <React.Fragment>
      <Container>
        <div className={styles.mainSection}>
          <Heading>Categories of Projects</Heading>
          <Paragraph color="#62677A">
            From energy solutions to technological advancements, our expertise{" "}
            <br /> spans diverse sectors.
          </Paragraph>

          {/* -------------slider-section------------ */}

          <Swiper
            slidesPerView={3.5}
            spaceBetween={30}
            autoplay={{
              delay: 2000,
              disableOnInteraction: false,
            }}
            modules={[Autoplay]}
            className="mySwiper"
            breakpoints={{
              320: {
                slidesPerView: 1,
                spaceBetween: 10,
              },
              768: {
                slidesPerView: 3.5,
                spaceBetween: 40,
              },
              1024: {
                slidesPerView: 3.5,
                spaceBetween: 40,
              },
            }}
          >
            <SwiperSlide>
              <div className={styles.cards}>
                <img
                  onClick={handleClickRedirect}
                  loading="lazy"
                  src="/images/project/windwill.png"
                  alt="windwill"
                />
                <h2>Renewable Energy</h2>
                <p>
                  Solar farms, rooftop systems, and hybrid renewable projects.
                </p>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className={styles.cards}>
                <img
                  onClick={handleClickRedirect}
                  loading="lazy"
                  src="/images/project/coal.png"
                  alt="windwill"
                />
                <h2>Commodities and Resources</h2>
                <p>
                  Efficient sourcing and delivery of coal, minerals, and
                  precious metals.
                </p>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className={styles.cards}>
                <img
                  onClick={handleClickRedirect}
                  loading="lazy"
                  src="/images/project/ai.png"
                  alt="windwill"
                />
                <h2>Technology intergration </h2>
                <p>
                  IoT-enabled monitoring systems for <br /> energy projects.
                </p>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className={styles.cards}>
                <img
                  onClick={handleClickRedirect}
                  loading="lazy"
                  src="/images/project/mine.jpg"
                  alt="windwill"
                />
                <h2>Infrastructure Development </h2>
                <p>
                  Clean water distribution systems and urban infrastructure
                  solutions.
                </p>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default ProjectSlider;
